export const arrayHasOddItem = (arr: unknown[]) => Boolean(arr.length > 1 && arr.length % 2);
